<div id="asset-form-container-{{assetIndex() + 1}}"
     class="w-full px-8 py-4 bg-white rounded-xl shadow flex-col input-wrap-custom">
  <div class="flex w-full justify-between">
    <h5 id="asset-title-label"
        class="general-font text-2xl font-semibold text-gray-700 uppercase ">
      Asset #{{ assetIndex() + 1 }}
    </h5>
    @if (assetsCount() > 1) {
      <button id="asset-delete-btn" (click)="onDeleteAsset()" class="pl-2 pr-2">
        <svg class="w-4 h-4 text-black " aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none"
             viewBox="0 0 24 24">
          <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M5 7h14m-9 3v8m4-8v8M10 3h4a1 1 0 0 1 1 1v3H9V4a1 1 0 0 1 1-1ZM6 7h12v13a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V7Z"/>
        </svg>
      </button>
    }
  </div>
  <div class="w-full flex flex-wrap gap-4">
    <div class="w-[48%] flex-col input-wrap-custom">
      <div class="input-wrap-custom">
        <div class="input-label-custom">Serial Number <span class="text-red-500">*</span></div>
        <div class="input-value-custom">
          <ng-select id="asset-serial-select-{{assetIndex() + 1}}" [items]="searchedAssets" bindValue="asset_id"
                     bindLabel="serial_number" [formControl]="assetsControl" required class="select-custom"
                     [addTag]="addCustomAsset" placeholder="Type at least 3 characters to search..."
                     (search)="onAssetSearch($event)" [searchFn]="showAll" (clear)="onAssetClear()">
            <ng-template ng-label-tmp let-item="item">
              <p>{{ item.serial_number }}</p>
              @if (item.serial_number && (item.make_name || item.model_name)) {
                <p>{{ item.make_name }} | {{ item.model_name }}</p>
              }
            </ng-template>
            <ng-template ng-option-tmp let-item="item" let-index="index">
              <div id="asset-serial-option-{{index}}-{{assetIndex() + 1}}">
                <p>{{ item.serial_number }}</p>
                @if (item.serial_number && (item.make_name || item.model_name)) {
                  <p>{{ item.make_name }} | {{ item.model_name }}</p>
                }
              </div>
            </ng-template>
          </ng-select>
          @if (assetsControl.invalid && (assetsControl.dirty || assetsControl.touched)) {
            <div id="asset-serial-error-{{assetIndex() + 1}}"
                 class="flex gap-2 text-xs pt-2 text-red-500">
              <custom-icon size="14.4px" iconName="fa-triangle-exclamation"/>
              <span>Serial Number is required.</span>
            </div>
          }
        </div>
      </div>
      <div class="input-wrap-custom">
        <div class="input-label-custom">Model <span class="text-red-500">*</span></div>
        <div class="input-value-custom">
          <ng-select id="asset-model-select-{{assetIndex() + 1}}" [items]="searchedModels" bindValue="model_id"
                     bindLabel="model_name" [formControl]="modelsControl" required class="select-custom"
                     [addTag]="addCustomModel" placeholder="Type at least 3 characters to search..."
                     (search)="onModelSearch($event)" [searchFn]="showAll" (clear)="onModelClear()">
            <ng-template ng-label-tmp let-item="item">
              {{ item.model_name }}
            </ng-template>
            <ng-template ng-option-tmp let-item="item" let-index="index">
              <div id="asset-model-option-{{index}}-{{assetIndex() + 1}}">
                <p>{{ item.model_name }}</p>
                @if (item.model_name && (item.make_name || item.type_name)) {
                  <p>{{ item.make_name }} | {{ item.type_name }}</p>
                }
              </div>
            </ng-template>
          </ng-select>
          @if (modelsControl.invalid && (modelsControl.dirty || modelsControl.touched)) {
            <div id="asset-model-error-{{assetIndex() + 1}}"
                 class="flex gap-2 text-xs pt-2 text-red-500">
              <custom-icon size="14.4px" iconName="fa-triangle-exclamation"/>
              <span>Model is required.</span>
            </div>
          }
        </div>
      </div>
      <div class="input-wrap-custom">
        <div class="input-label-custom">Make <span class="text-red-500">*</span></div>
        <div class="input-value-custom">
          <ng-select id="asset-make-select-{{assetIndex() + 1}}" [items]="searchedMakes" bindValue="make_id"
                     bindLabel="make_name" [formControl]="makesControl" required class="select-custom"
                     [addTag]="addCustomMake" placeholder="Type at least 3 characters to search..."
                     (search)="onMakeSearch($event)" (clear)="onMakeClear()">
            <ng-template ng-option-tmp let-item="item" let-index="index">
              <div id="asset-make-option-{{index}}-{{assetIndex() + 1}}">
                {{ item.make_name }}
              </div>
            </ng-template>
          </ng-select>
          @if (makesControl.invalid && (makesControl.dirty || makesControl.touched)) {
            <div id="asset-make-error-{{assetIndex() + 1}}"
                 class="flex gap-2 text-xs pt-2 text-red-500">
              <custom-icon size="14.4px" iconName="fa-triangle-exclamation"/>
              <span>Make is required.</span>
            </div>
          }
        </div>
      </div>
      <div class="input-wrap-custom">
        <div class="input-label-custom">Type <span class="text-red-500">*</span></div>
        <div class="input-value-custom">
          <ng-select id="asset-type-select-{{assetIndex() + 1}}" [items]="searchedTypes" bindValue="type_id"
                     bindLabel="type_name" [formControl]="typesControl" required class="select-custom"
                     [addTag]="addCustomType" placeholder="Type at least 3 characters to search..."
                     (search)="onTypeSearch($event)" (clear)="onTypeClear()">
            <ng-template ng-option-tmp let-item="item" let-index="index">
              <div id="asset-type-option-{{index}}-{{assetIndex() + 1}}">
                {{ item.type_name }}
              </div>
            </ng-template>
          </ng-select>
          @if (typesControl.invalid && (typesControl.dirty || typesControl.touched)) {
            <div id="asset-type-error-{{assetIndex() + 1}}"
                 class="flex gap-2 text-xs pt-2 text-red-500">
              <custom-icon size="14.4px" iconName="fa-triangle-exclamation"/>
              <span>Type is required.</span>
            </div>
          }
        </div>
      </div>
      <div class="input-wrap-custom">
        <div class="input-label-custom">PO Number</div>
        <div class="input-value-custom">
          <input id="asset-po-input-{{assetIndex() + 1}}" [(ngModel)]="asset.po_number" type="text"
                 class="input-custom"/>
        </div>
      </div>
      <div class="input-wrap-custom">
        <div class="input-label-custom">Tracking Number</div>
        <div class="input-value-custom">
          <input id="asset-tracking-input-{{assetIndex() + 1}}" [(ngModel)]="asset.tracking_number" type="text"
                 class="input-custom"/>
        </div>
      </div>
      <div class="input-wrap-custom">
        <div class="input-label-custom">Issue Description <span class="text-red-500">*</span></div>
        <div class="input-value-custom">
                <textarea id="asset-issue-textarea-{{assetIndex() + 1}}" [(ngModel)]="asset.issue_description"
                          class="input-custom" rows="4" [formControl]="issueControl" required></textarea>
          @if (issueControl.invalid && (issueControl.dirty || issueControl.touched)) {
            <div id="asset-issue-error-{{assetIndex() + 1}}"
                 class="flex gap-2 text-xs pt-2 text-red-500">
              <custom-icon size="14.4px" iconName="fa-triangle-exclamation"/>
              <span>Issue Description is required.</span>
            </div>
          }
        </div>
      </div>
    </div>
    <div class="flex-col input-wrap-custom">
      <div class="input-wrap-custom">
        <div class="input-label-custom">PM Preapproval</div>
        <div class="input-value-custom">
          <label class="inline-flex items-center cursor-pointer">
            <input id="asset-pm-preapproval-toggle-{{assetIndex() + 1}}" [(ngModel)]="asset.pm_preapproval"
                   type="checkbox" class="sr-only peer"/>
            <div
              class="relative w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
          </label>
        </div>
      </div>
      <div class="input-wrap-custom">
        <div class="input-label-custom">Accessories Included</div>
        <div class="input-value-custom">
          <label class="inline-flex items-center cursor-pointer">
            <input id="asset-accessories-toggle-{{assetIndex() + 1}}" [(ngModel)]="asset.accesory_included"
                   type="checkbox" class="sr-only peer"/>
            <div
              class="relative w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
          </label>
        </div>
      </div>
      @if (asset.accesory_included) {
        <div class="input-wrap-custom">
          <div class="input-label-custom">Accessories</div>
          <div class="input-value-custom">
                      <textarea id="asset-accessories-textarea-{{assetIndex() + 1}}" [(ngModel)]="asset.accessory"
                                class="input-custom" rows="4"></textarea>
          </div>
        </div>
      }
      <div class="input-wrap-custom">
        <div class="input-label-custom">Battery Sent In</div>
        <div class="input-value-custom">
          <label class="inline-flex items-center cursor-pointer">
            <input id="asset-battery-toggle-{{assetIndex() + 1}}" [(ngModel)]="asset.battery_sent_in" type="checkbox"
                   class="sr-only peer"/>
            <div
              class="relative w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
          </label>
        </div>
      </div>
      <div class="input-wrap-custom">
        <div class="input-label-custom">Power Cord Sent In</div>
        <div class="input-value-custom">
          <label class="inline-flex items-center cursor-pointer">
            <input id="asset-power-cord-toggle-{{assetIndex() + 1}}" [(ngModel)]="asset.power_cord_sent_in"
                   type="checkbox" class="sr-only peer"/>
            <div
              class="relative w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
          </label>
        </div>
      </div>
      <div class="input-wrap-custom">
        <div class="input-label-custom">Service Contract</div>
        <div class="input-value-custom">
          <ng-select id="asset-service-contract-select-{{assetIndex() + 1}}" [(ngModel)]="asset.service_contract"
                     required class="select-custom" [virtualScroll]="true">
            <ng-option id="asset-service-contract-option-yes-{{assetIndex() + 1}}" [value]="1">Yes</ng-option>
            <ng-option id="asset-service-contract-option-no-{{assetIndex() + 1}}" [value]="3">No</ng-option>
            <ng-option id="asset-service-contract-option-unknown-{{assetIndex() + 1}}" [value]="2">Not Sure</ng-option>
          </ng-select>
        </div>
      </div>
      <div class="input-wrap-custom">
        <div class="input-label-custom">PM Contract</div>
        <div class="input-value-custom">
          <ng-select id="asset-pm-contract-select-{{assetIndex() + 1}}" [(ngModel)]="asset.pm_contract"
                     class="select-custom" [virtualScroll]="true">
            <ng-option id="asset-pm-contract-option-yes-{{assetIndex() + 1}}" [value]="1">Yes</ng-option>
            <ng-option id="asset-pm-contract-option-no-{{assetIndex() + 1}}" [value]="3">No</ng-option>
            <ng-option id="asset-pm-contract-option-unknown-{{assetIndex() + 1}}" [value]="2">Not Sure</ng-option>
          </ng-select>
        </div>
      </div>
      <div class="input-wrap-custom">
        <div class="input-label-custom">Under Warranty</div>
        <div class="input-value-custom">
          <ng-select id="asset-warranty-select-{{assetIndex() + 1}}" [(ngModel)]="asset.under_warranty"
                     class="select-custom" [virtualScroll]="true">
            <ng-option id="asset-warranty-option-yes-{{assetIndex() + 1}}" [value]="1">Yes</ng-option>
            <ng-option id="asset-warranty-option-no-{{assetIndex() + 1}}" [value]="3">No</ng-option>
            <ng-option id="asset-warranty-option-unknown-{{assetIndex() + 1}}" [value]="2">Not Sure</ng-option>
          </ng-select>
        </div>
      </div>
    </div>
  </div>
  <div class="w-[48%] input-wrap-custom">
    <div class="input-label-custom">Attachment(s)</div>
    <div class="input-value-custom">
      <input [id]="'photoInput-' + assetIndex()" [disabled]="asset.serial_number == null || asset.serial_number == ''"
             type="file" class="hidden" (change)="onPhotoSelected($event, asset.service_request_asset_number)"
             multiple/>
      <label [for]="'photoInput-' + assetIndex()" id="asset-attachment-browse-btn-{{assetIndex() + 1}}"
             class="flex gap-1 justify-center items-center w-[300px] p-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 cursor-pointer">
        <custom-icon size="19px" iconName="fa-upload"/>
        <span>Browse</span>
      </label>
    </div>
  </div>

  <div id="asset-attachments-container-{{assetIndex() + 1}}" class="flex flex-wrap">
    @for (attachment of asset.attachments; track $index; let i = $index) {
      <div id="asset-attachment-{{i}}-{{assetIndex() + 1}}"
           class="photo-item w-[300px] h-[300px] flex flex-col items-center border border-gray-300 rounded-md m-2 p-2">
        @if (isSupportedFileType(attachment.fileName)) {
          <img [src]="attachment.url" alt="Uploaded Photo" class="object-contain w-200 h-[200px] rounded-md"
               (click)="showFullPhoto(attachment)"/>
        }
        @if (!isSupportedFileType(attachment.fileName)) {
          <img src="https://www.iconpacks.net/icons/2/free-file-icon-1453-thumb.png" alt="Unsupported File Type"
               class="object-contain w-200 h-[200px] rounded-md"/>
        }
        <span class="block truncate w-[200px] text-center">{{ attachment.fileName }}</span>
        <button id="asset-attachment-delete-{{i}}-{{assetIndex() + 1}}" (click)="removePhoto(i)"
                class="remove-button mt-auto">
          <svg class="w-6 h-6 text-black" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none"
               viewBox="0 0 24 24">
            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M5 7h14m-9 3v8m4-8v8M10 3h4a1 1 0 0 1 1 1v3H9V4a1 1 0 0 1 1-1ZM6 7h12v13a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V7Z"/>
          </svg>
        </button>
      </div>
    }
  </div>

  <!-- Modal -->
  @if (modalOpen) {
    <div id="asset-photo-modal-{{assetIndex() + 1}}"
         class="fixed top-0 left-0 w-full h-full flex justify-center items-center bg-black bg-opacity-50"
         (click)="closeModal($event)">
      <div class="max-w-screen-lg" stopClickPropagation>
        <img [src]="modalImageUrl" alt="Modal Photo" class="max-w-full object-contain" style="max-height: 500px;"/>
      </div>
    </div>
  }
</div>
